
  import documentService from "../../services/deliveryexperience/documentService";
  import { renderAsync } from "docx-preview";
  import JSZip from "jszip";
  import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

  export default {
    name: "preview-document-modal",
    props: {
      id: String
    },
    data() {
      return {
        docUrl: "",
        docName: "",
        docHtml: "",
        isDocx: false,
        isZip: false,
        zipFiles: []
      };
    },
    methods: {
      formatFileName(fileName) {
        const parts = fileName.split("/");
        if (parts.length > 1) {
          const folderPath = parts.slice(0, -1).join("/") + "/";
          const fileNameBold = `<b>${parts[parts.length - 1]}</b>`;
          return `${folderPath}${fileNameBold}`;
        }
        return `<b>${fileName}</b>`;
      },
      async openDoc(doc) {
        this.docName = doc.name;
        const extension = doc.name.split(".").pop().toLowerCase();

        this.isDocx = false;
        this.isZip = false;
        this.zipFiles = [];

        const download = await documentService.methods.downloadDocumentFromBlob(
          doc.url
        );

        if (extension === "docx") {
          this.isDocx = true;
          const reader = new FileReader();

          reader.onload = async event => {
            const arrayBuffer = event.target?.result as ArrayBuffer;
            const container = document.createElement("div");

            await renderAsync(arrayBuffer, container);
            this.docHtml = container.innerHTML;
          };

          reader.readAsArrayBuffer(
            new Blob([download.blob], { type: download.type })
          );
        } else if (extension === "zip") {
          this.isZip = true;
          const zip = new JSZip();
          const reader = new FileReader();

          reader.onload = async event => {
            const arrayBuffer = event.target?.result as ArrayBuffer;
            const zipContent = await zip.loadAsync(arrayBuffer);
            this.zipFiles = [];

            zipContent.forEach((relativePath, file) => {
              this.zipFiles.push({
                name: file.name
              });
            });
          };

          reader.readAsArrayBuffer(
            new Blob([download.blob], { type: download.type })
          );
        } else {
          this.docUrl = window.URL.createObjectURL(
            new Blob([download.blob], { type: download.type })
          );
        }

        this.$refs.readDoc.show();
      }
    },
    components: {
      FontAwesomeIcon
    }
  };
